import X from './src/x-combined';
export default X;